import store from '@/store/index.js'
let dic = store.state.dic;
import porvince from "@/assets/json/province.js";
export default function Configs(that) {
    const searchItems = [
        {
            label: "规则类型",
            span: 8,
            type: 'select',
            placeholder: '请输入地点名称',
            model: "type",
            options: [
                { label: '不允许调整专业', value: 1 },
                { label: '允许在本专业类别范围内调整专业', value: 2 },
                { label: '必须在专业范围内调整专业', value: 3 },
            ],
        },

    ]
    const tableColumns = [
        {
            label: "规则名称",
            prop: "name",
            align: "center",
            show: true
        },
        {
            label: "专业列表",
            prop: "majorName",
            align: "center",
            show: true
        },
        {
            label: "学生类别",
            prop: "studentTypeName",
            align: "center",
            show: true,
        },
        {
            label: "学生省份",
            prop: "provinceName",
            align: "center",
            show: true
        },
        {
            label: "调整规则",
            name: 'custom',
            align: "center",
            show: true
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '200px',
            show: true
        }
    ]
    const formItems = [
        {
            label: "规则名称",
            span: 24,
            model: "name",
            placeholder: '请设置规则名称',
            labelClass: 'info-label',
        },
        {
            label: "规则类型",
            span: 24,
            min: 1,
            model: "type",
            type: 'select',
            options: [
                { label: '不允许调整专业', value: 1 },
                { label: '允许在本专业类别范围内调整专业', value: 2 },
                { label: '必须在专业范围内调整专业', value: 3 },
            ],
            placeholder: '请选择规则类型',
            labelClass: 'info-label',
        },
        {
            label: "学生类别",
            span: 24,
            model: "studentTypeList",
            type: 'select',
            placeholder: '请选择学生类别',
            options: [
                { label: '普通类型', value: "0" },
                { label: '体育生', value: "1" },
                { label: '单招', value: "2" },
                { label: '艺术生', value: "3" },
                { label: '技能类', value: "4" },
                { label: '精准扶贫类', value: "5" },
            ],
            multiple: true,
            labelClass: 'info-label',
        },
        {
            label: "学生省份",
            span: 24,
            model: "provinceCodeList",
            type: 'select',
            options: porvince,
            multiple: true,
            placeholder: '请选择学生省份',
            labelClass: 'info-label',
        },

    ]

    const formRules = {
        name: [{
            required: true,
            trigger: "blur",
            message: '请设置规则名称'
        }],
        type: [{
            required: true,
            trigger: "change",
            message: '请选择规则类型'
        }],
        toMajorIdList: [{
            required: true,
            trigger: "blur",
            message: '请选择调入专业'
        }],
    }


    const tree = {
        props: {
            parent: "parentId", // 父级唯一标识
            value: "id", // 唯一标识
            label: "name", // 标签显示
            children: "children" // 子级
        }
    }
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules,
        tree
    }
}
